import { IButtonTheme } from '../../models/IButtonTheme';
import { colors } from './colors';

export const ButtonTheme: IButtonTheme = {
  isPull: false,
  borderRadius: {
    normal: '0.188rem',
    pill: '10rem',
  },
  sizes: {
    xs: {
      fontSize: '12px',
      fontWeight: 100,
      lineHeight: '12px',
      padding: '3px 10px',
    },
    sm: {
      fontSize: '17px',
      fontWeight: 700,
      lineHeight: '20px',
      padding: '4px 10px',
    },
    md: {
      fontSize: '14px',
      fontWeight: 100,
      lineHeight: '20px',
      padding: '11px 33px',
    },
  },
  type: {
    primary: {
      variants: {
        transactional: {
          default: {
            textDecoration: 'none',
            color: colors.neutral.white,
            borderColor: colors.transactional.base,
            backgroundColor: colors.transactional.base,
          },
          hover: {
            textDecoration: 'none',
            color: colors.neutral.white,
            borderColor: colors.transactional.shaded,
            backgroundColor: colors.transactional.shaded,
          },
          active: {
            textDecoration: 'none',
            color: colors.neutral.white,
            borderColor: colors.transactional.dark,
            backgroundColor: colors.transactional.dark,
          },
          disabled: {
            textDecoration: 'none',
            color: colors.neutral.grayMedium,
            borderColor: colors.neutral.grayLight,
            backgroundColor: colors.neutral.grayLight,
          },
        },
        notTransactional: {
          default: {
            textDecoration: 'none',
            color: colors.neutral.white,
            borderColor: colors.notTransactional.base,
            backgroundColor: colors.notTransactional.base,
          },
          hover: {
            textDecoration: 'none',
            color: colors.neutral.white,
            borderColor: colors.notTransactional.shaded,
            backgroundColor: colors.notTransactional.shaded,
          },
          active: {
            textDecoration: 'none',
            color: colors.neutral.white,
            borderColor: colors.notTransactional.dark,
            backgroundColor: colors.notTransactional.dark,
          },
          disabled: {
            textDecoration: 'none',
            color: colors.neutral.grayMedium,
            borderColor: colors.neutral.grayLight,
            backgroundColor: colors.neutral.grayLight,
          },
        },
        ghost: {
          default: {
            textDecoration: 'none',
            color: colors.notTransactional.base,
            borderColor: colors.neutral.transparent,
            backgroundColor: colors.neutral.transparent,
          },
          hover: {
            textDecoration: 'none',
            color: colors.notTransactional.base,
            borderColor: colors.neutral.grayLight,
            backgroundColor: colors.neutral.grayLight,
          },
          active: {
            textDecoration: 'none',
            color: colors.notTransactional.shaded,
            borderColor: colors.neutral.grayLight,
            backgroundColor: colors.neutral.grayLight,
          },
          disabled: {
            textDecoration: 'none',
            color: colors.neutral.grayMedium,
            borderColor: colors.neutral.transparent,
            backgroundColor: colors.neutral.transparent,
          },
        },
      },
    },
    secondary: {
      variants: {
        transactional: {
          default: {
            textDecoration: 'none',
            color: colors.transactional.base,
            borderColor: colors.transactional.base,
            backgroundColor: colors.neutral.white,
          },
          hover: {
            textDecoration: 'none',
            color: colors.neutral.white,
            borderColor: colors.transactional.base,
            backgroundColor: colors.transactional.base,
          },
          active: {
            textDecoration: 'none',
            color: colors.neutral.white,
            borderColor: colors.transactional.dark,
            backgroundColor: colors.transactional.dark,
          },
          disabled: {
            textDecoration: 'none',
            color: colors.neutral.grayMedium,
            borderColor: colors.neutral.grayLight,
            backgroundColor: colors.neutral.grayLight,
          },
        },
        notTransactional: {
          default: {
            textDecoration: 'none',
            color: colors.notTransactional.base,
            borderColor: colors.notTransactional.base,
            backgroundColor: colors.neutral.white,
          },
          hover: {
            textDecoration: 'none',
            color: colors.neutral.white,
            borderColor: colors.notTransactional.base,
            backgroundColor: colors.notTransactional.base,
          },
          active: {
            textDecoration: 'none',
            color: colors.neutral.white,
            borderColor: colors.notTransactional.dark,
            backgroundColor: colors.notTransactional.dark,
          },
          disabled: {
            textDecoration: 'none',
            color: colors.neutral.grayMedium,
            borderColor: colors.neutral.grayLight,
            backgroundColor: colors.neutral.grayLight,
          },
        },
        ghost: {
          default: {
            textDecoration: 'none',
            color: colors.notTransactional.base,
            borderColor: colors.neutral.transparent,
            backgroundColor: colors.neutral.transparent,
          },
          hover: {
            textDecoration: 'none',
            color: colors.notTransactional.base,
            borderColor: colors.neutral.grayLight,
            backgroundColor: colors.neutral.grayLight,
          },
          active: {
            textDecoration: 'none',
            color: colors.notTransactional.shaded,
            borderColor: colors.neutral.grayLight,
            backgroundColor: colors.neutral.grayLight,
          },
          disabled: {
            textDecoration: 'none',
            color: colors.neutral.grayMedium,
            borderColor: colors.neutral.transparent,
            backgroundColor: colors.neutral.transparent,
          },
        },
      },
    },
  },
};
